import React, { useContext } from "react";
import { digitsThree } from "../../../utils/price";
import { context } from "../../../context/context";

function BrrowerAllInfo({ data }) {
  const { utils } = useContext(context);

  return (
    <div>
      <h3>اطلاعات وام گیرنده</h3>
      <h4 className="mt-4">مشخصات</h4>
      <div className="flex flex-col gap-3 text-gray-500 py-4">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <p className="w-full text-center sm:text-right">
            نام وام گیرنده : {data?.user?.name || "-"}
          </p>
          <p className="w-full text-center sm:text-right">
            کد ملی : {data?.nationalId || "-"}
          </p>
          <p className="w-full text-center sm:text-right">
            موبایل : {data?.mobile || "-"}
          </p>
          <p className="w-full text-center sm:text-right">
            شماره حساب : {data?.bankAccountId || "-"}
          </p>
          <p className="w-full text-center sm:text-right">
            توضیحات شغلی : {data?.jobDescription || "-"}
          </p>
        </div>
      </div>

      <h4>اعتبار سنجی</h4>
      <div className="flex flex-col gap-3 text-gray-500 py-4">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <p className="w-full text-center sm:text-right">
            مبلغ وام : {digitsThree(data?.amount) || "-"}
          </p>
          <p className="w-full text-center sm:text-right">
            مانده سقف ضمانت :{" "}
            {digitsThree(data?.remainingGuaranteeLimit) || "-"}
          </p>
          <p className="w-full text-center sm:text-right">
            مبلغ سفته : {digitsThree(data?.promissoryNote) || "-"}
          </p>
          <p className="w-full text-center sm:text-right">
            مبلغ قسط : {digitsThree(data?.installmentAmount) || "-"}
          </p>
          <p className="w-full text-center sm:text-right">
            وضعیت اعتبار سنجی :{" "}
            {utils?.CREDIT_TYPE?.[data?.creditType]?.name || "-"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default BrrowerAllInfo;
